<template>
  <!-- {{ sessionExpirationTime }} -->
  <div v-if="currentStep == 0">
    <CardListing
      :type="resumeBundleType ? resumeBundleType : prop.type"
      @jump-step="jumpStep"
      @set-card-id="setCardId"
      @set-card-name="setCardName"
      :countDown="formattedTime"
      @close-modal="closeTimeOut"
      :selected-card="ccFormValue.selectedCard"
      :nationality="
        ccFormValue.basicInformation.nationality == 'MY' ? 'MY' : 'NON-MY'
      "
      :gross-salary="ccFormValue.basicInformation.grossSalary"
      :webFormRequestId="prop.webFormRequestId"
      :resumeId="ccFormValue.webFormRequestId"
      :cardId="prop.cardId"
      :overlay="page0Overlay"
      :token="ccFormValue.token"
      @submit="
        prop.type == 'CR_SL' ? crossSellingCardSubmit() : biometricCardSubmit()
      "
      @overlay="is0Overlay"
      @close-overlay="close0Overlay"
      @disabledPopout="disabledPopout"
      @enabledPopout="enabledPopout"
      @tokenSessionTimeOut="tokenSessionTimeOut"
      :pfExpired="prop.reminderValue ? prop.reminderValue.pfExpired : false"
      @emptyCardSubmit="cardSubmit()"
      :isAutoPopulate="prop.isAutoPopulate"
      :multiChannel="multiChannel"
      :creditLimit="creditLimit"
      @getProductStep="getProductStepFromBackend"
      :productBundlingExpiredtype="
        prop.reminderValue?.productBundlingExpiredtype
          ? prop.reminderValue?.productBundlingExpiredtype
          : ''
      "
    ></CardListing>
  </div>

  <div v-if="currentStep == 1">
    <BasicInformation
      @jump-step="jumpStep"
      @next-step="nextStep"
      :basic-information="ccFormValue.basicInformation"
      @submit="
        prop.type !== 'BIO'
          ? prop.type == 'FINPLUS'
            ? handleFinplusSubmit()
            : handleBasicInformationSubmit()
          : handleBiometricSubmit()
      "
      :status="status"
      :newForm="newForm"
      :otp="otp"
      :overlay="page1Overlay"
      :cardName="ccFormValue.cardName"
      :cardMinSalary="ccFormValue.cardMinSalary"
      :cardId="prop.cardId"
      :ekyc="ccFormValue.ekyc.status"
      :countDown="formattedTime"
      :selected-card="ccFormValue.selectedCard"
      @overlay="isOverlay"
      @close-overlay="closeOverlay"
      :type="prop.type"
      :webFormRequestId="prop.webFormRequestId"
      :isAutoPopulate="prop.isAutoPopulate"
      :autoPopulateDisabledField="autoPopulateDisabledField"
      :populatedIdInfo="populatedIdInfo"
      :pfExpired="prop.reminderValue ? prop.reminderValue.pfExpired : false"
      :verification="biometricVerification"
      :acc="multiChannel.acc"
    ></BasicInformation>
  </div>
  <div v-else-if="currentStep == 2">
    <Qrcode
      @next-step="nextStep"
      @previous-step="previousStep"
      :ekyc="ccFormValue.ekyc"
      @ekycGenerate="qr"
      @listenerEkyc="listenerEkyc"
      @jump-step="jumpStep"
      :ekycGetFailed="ekycGetFailed"
      :cardName="ccFormValue.cardName"
      :overlay="page2Overlay"
      @updateFlag="updateFlag"
      :otpVerified="otp.verified"
      @submit="handleQrcodeSubmit"
      :preStatus="ccFormValue.ekyc.preStatus"
      :failedStatus="failedStatus"
      :type="prop.type"
      :token="ccFormValue.token"
      @updateOTPFlag="updateOTPFlag"
      @tokenSessionTimeOut="tokenSessionTimeOut"
    ></Qrcode>
  </div>
  <div v-else-if="currentStep == 3">
    <ContactVerification
      @next-step="nextStep"
      @previous-step="previousStep"
      :contact-information="ccFormValue"
      @jump-step="jumpStep"
      @submit="preAssesment"
      :otp="otp"
      :cardName="ccFormValue.cardName"
      :overlay="page3Overlay"
      :type="prop.type"
      :verification="biometricVerification"
      :token="ccFormValue.token"
      @tokenSessionTimeOut="tokenSessionTimeOut"
    >
    </ContactVerification>
  </div>
  <div v-else-if="currentStep == 4">
    <PersonalInformation
      @jump-step="jumpStep"
      :personal-information="ccFormValue.personalInformation"
      :nationality="ccFormValue.basicInformation.nationality"
      @submit="handlePersonalInformationSubmit"
      :overlay="page4Overlay"
      :cardName="ccFormValue.cardName"
      :summary-setting="ccFormValue.summarySetting"
      :type="prop.type"
      :countDown="formattedTime"
      :webFormRequestId="prop.webFormRequestId"
      :isAutoPopulate="prop.isAutoPopulate"
      :verification="biometricVerification"
    ></PersonalInformation>
  </div>
  <div v-else-if="currentStep == 5">
    <EmergencyContact
      @previous-step="previousStep"
      :emergency-contact="ccFormValue.emergencyContact"
      @submit="handleEmergencyContactSubmit"
      :overlay="page5Overlay"
      :cardName="ccFormValue.cardName"
      :mobileNo="
        ccFormValue.basicInformation.countryCode +
        ccFormValue.basicInformation.mobileNo
      "
      :summary-setting="ccFormValue.summarySetting"
      :pfExpired="prop.reminderValue ? prop.reminderValue.pfExpired : false"
      :type="prop.type"
    ></EmergencyContact>
  </div>
  <div v-else-if="currentStep == 6">
    <EmploymentDetails
      @next-step="nextStep"
      @previous-step="previousStep"
      :employment-details="ccFormValue.employmentDetails"
      :dob="ccFormValue.basicInformation.dob"
      @submit="handleEmploymentSubmit"
      :overlay="page6Overlay"
      :idType="ccFormValue.basicInformation.idType"
      :pensioneer="ccFormValue.basicInformation.profession"
      :cardName="ccFormValue.cardName"
      :summary-setting="ccFormValue.summarySetting"
      :isAutoPopulate="prop.isAutoPopulate"
      :populatedIdInfo="populatedIdInfo"
      :pfExpired="prop.reminderValue ? prop.reminderValue.pfExpired : false"
      :type="prop.type"
    ></EmploymentDetails>
  </div>
  <div v-else-if="currentStep == 7">
    <PrincipalCardDetails
      @next-step="nextStep"
      @previous-step="previousStep"
      @jump-step="jumpStep"
      :principal-details="ccFormValue.principalDetails"
      :ekyc="ccFormValue.ekyc.status"
      :workplace="ccFormValue.employmentDetails.question2"
      @submit="principalSubmit"
      :address="ccFormValue.personalInformation"
      :overlay="page7Overlay"
      :profession="ccFormValue.basicInformation.profession"
      :idType="ccFormValue.basicInformation.idType"
      :cardId="prop.cardId"
      :cardName="ccFormValue.cardName"
      :summary-setting="ccFormValue.summarySetting"
      :type="prop.type"
      :countDown="formattedTime"
      :verification="biometricVerification"
    ></PrincipalCardDetails>
  </div>
  <div v-else-if="currentStep == 8">
    <UploadDocuments
      @next-step="nextStep"
      @previous-step="previousStep"
      @jump-step="jumpStep"
      :cc-form="ccFormValue"
      @submit="fileSubmit"
      :overlay="page8Overlay"
      :cardName="ccFormValue.cardName"
      :summary-setting="ccFormValue.summarySetting"
      :type="resumeBundleType ? resumeBundleType : prop.type"
      :countDown="formattedTime"
      :pfExpired="prop.reminderValue ? prop.reminderValue.pfExpired : false"
      :productBundlingExpiredtype="
        prop.reminderValue?.productBundlingExpiredtype
          ? prop.reminderValue?.productBundlingExpiredtype
          : ''
      "
      :uploadFileValidity="uploadFileValidity"
      :cardId="prop.cardId"
      :webFormRequestId="prop.webFormRequestId"
      @getProductStep="getProductStepFromBackend"
    ></UploadDocuments>
  </div>
  <div v-else-if="currentStep == 9">
    <SupplementaryCardDetails
      @next-step="nextStep"
      @previous-step="previousStep"
      @jump-step="jumpStep"
      :supplementary="ccFormValue.supplementary"
      :otp="otp"
      :mobileNo="
        ccFormValue.basicInformation.countryCode +
        ccFormValue.basicInformation.mobileNo
      "
      @submit="suppSubmit"
      :cardName="ccFormValue.cardName"
      :overlay="page9Overlay"
      :summary-setting="ccFormValue.summarySetting"
    >
    </SupplementaryCardDetails>
  </div>
  <div v-else-if="currentStep == 10">
    <SupplementaryContactVerification
      @next-step="nextStep"
      @previous-step="previousStep"
      @jump-step="jumpStep"
      :contactInformation="ccFormValue"
      :otp="otp"
      :cardName="ccFormValue.cardName"
      :suppId="ccFormValue.supplementary.webFormRequestId"
      @submit="suppOtpFail"
      :overlay="page10Overlay"
      :token="ccFormValue.token"
      @tokenSessionTimeOut="tokenSessionTimeOut"
    >
    </SupplementaryContactVerification>
  </div>
  <div v-else-if="currentStep == 11">
    <SupplementaryUploadFile
      @next-step="nextStep"
      @previous-step="previousStep"
      @jump-step="jumpStep"
      :cc-form="ccFormValue"
      :overlay="page11Overlay"
      @submit="suppFileSubmit"
      :cardName="ccFormValue.cardName"
      :summary-setting="ccFormValue.summarySetting"
      :uploadFileValidity="uploadFileValidity"
      :type="prop.type"
      :webFormRequestId="prop.webFormRequestId"
    >
    </SupplementaryUploadFile>
  </div>
  <div v-else-if="currentStep == 12">
    <Summary
      @jump-step="jumpStep"
      @submit="handleSummarySubmit"
      :cc-form="ccFormValue"
      :cardId="cardId"
      :cardName="ccFormValue.cardName"
      :overlay="page12Overlay"
      :type="resumeBundleType ? resumeBundleType : prop.type"
      :countDown="formattedTime"
      :token="ccFormValue.token"
      :pfExpired="prop.reminderValue ? prop.reminderValue.pfExpired : false"
      :acc="multiChannel.acc"
      @tokenSessionTimeOut="tokenSessionTimeOut"
      @getProductStep="getProductStepFromBackend"
    ></Summary>
  </div>
  <div v-else-if="currentStep == 13">
    <TermsCondition
      @previous-step="previousStep"
      @jump-step="jumpStep"
      @submit="declarationSubmit"
      @close="closeTNCModal"
      :cc-form="ccFormValue"
      :termsSubmitFail="termsSubmitFail"
      :overlay="page13Overlay"
      :cardName="ccFormValue.cardName"
      :type="resumeBundleType ? resumeBundleType : prop.type"
      :countDown="formattedTime"
      :isAutoPopulate="prop.isAutoPopulate"
      :populatedIdInfo="populatedIdInfo"
      @getProductStep="getProductStepFromBackend"
    ></TermsCondition>
  </div>
  <div v-else-if="currentStep == 14">
    <Acknowledgement
      :status="status"
      :webFormRequestId="ccFormValue.webFormRequestId"
      :cardId="cardId"
      :icNo="ccFormValue.basicInformation.idNo"
      :creditLimit="creditLimit"
      :refNo="ccFormValue.refNo"
      :cardName="ccFormValue.cardName"
      :score="ccFormValue.ctosScore"
      :dsr="ccFormValue.dsrBurst"
      @jump-step="jumpStep"
      @set-card-id="setCardId"
      @set-card-name="setCardName"
      :selected-card="ccFormValue.selectedCard"
      :countDown="formattedTime"
      :nationality="
        ccFormValue.basicInformation.nationality == 'MY' ? 'MY' : 'NON-MY'
      "
      :grossSalary="ccFormValue.basicInformation.grossSalary"
      :type="prop.type"
      :preStatus="ccFormValue.ekyc.preStatus"
      :changeApplicationFlag="changeApplicationFlag"
      :token="ccFormValue.token"
      @tokenSessionTimeOut="tokenSessionTimeOut"
      :isDraft="prop.isDraft"
      :acc="multiChannel.acc"
    ></Acknowledgement>
  </div>
  <div v-else-if="currentStep == 15">
    <AdditionalInformation
      @jump-step="jumpStep"
      @previous-step="previousStep"
      :personal-information="ccFormValue.personalInformation"
      :principal-details="ccFormValue.principalDetails"
      :address="ccFormValue.personalInformation"
      :ekyc="ccFormValue.ekyc.status"
      :nationality="ccFormValue.basicInformation.nationality"
      @submit="handleAdditionalInformationSubmit"
      :overlay="page15Overlay"
      :cardName="ccFormValue.cardName"
      :summary-setting="ccFormValue.summarySetting"
      :type="resumeBundleType ? resumeBundleType : prop.type"
      :countDown="formattedTime"
      :status="status"
      :basic-information="ccFormValue.basicInformation"
      :idType="ccFormValue.basicInformation.idType"
      :workplace="ccFormValue.employmentDetails.question2"
      :employment-details="ccFormValue.employmentDetails"
      :verification="biometricVerification"
      @getProductStep="getProductStepFromBackend"
    >
    </AdditionalInformation>
  </div>

  <div v-else-if="currentStep == 16">
    <BiometricStart
      @jump-step="jumpStep"
      :webFormRequestId="prop.webFormRequestId"
      :biometricStartInfo="biometricStartInfo"
      :token="prop.token"
    >
    </BiometricStart>
  </div>

  <div v-else-if="currentStep == 101">
    <LandingPage
      :type="prop.type"
      :resumeInfo="resumeInfo"
      :ccFormValue="ccFormValue"
      @jump-step="jumpStep"
      :loading="getDataLanding"
      :resumeDraftData="resumeDraftData"
      @submit="getPopulateData"
      @newApplication="newApplication"
      @overlay="landingPageOverlay"
      :mc="multiChannel.mc"
      :acc="multiChannel.acc"
    ></LandingPage>
  </div>

  <div v-else-if="currentStep == 102">
    <PersonalInfo
      :ccFormValue="ccFormValue"
      :resumeApplication="resumeApplication"
      :resumeInfo="resumeInfo"
      :resumeDraftData="resumeDraftData"
      :recruiterId="prop.rci ? prop.rci : biometricStartInfo.recruiterId"
      :verification="biometricVerification"
      :type="prop.type"
      :cardId="prop.cardId"
      :webFormRequestId="prop.webFormRequestId"
      :biometricCardList="prop.biometricCardList"
      :biometricStartInfo="biometricStartInfo"
      :resumeOtp="resumeOtp"
      :autoPopulationOtp="autoPopulationOtp"
      @resetAutoPopulationOtp="resetAutoPopulationOtp"
      @jump-step="jumpStep"
      @newApplication="newApplication"
    ></PersonalInfo>
  </div>

  <div v-else-if="currentStep == 103">
    <OTPVerification
      @next-step="nextStep"
      @previous-step="previousStep"
      :resumeInfo="resumeInfo"
      @jump-step="jumpStep"
      :otp="resumeOtp"
      :type="prop.type"
      :resumeDraftData="resumeDraftData"
      :resumeWebFormRequestId="prop.resumeWebFormRequestId"
      :isReminder="prop.isReminder"
      :cardId="prop.cardId"
      :resumeApplication="resumeApplication"
      :backSource="otpBackSource"
      @newApplication="newApplication"
    ></OTPVerification>
  </div>

  <div v-else-if="currentStep == 104">
    <NoDraft
      @jump-step="jumpStep"
      @newApplication="newApplication"
      @submit="getPopulateData"
      :type="prop.type"
      :cardId="prop.cardId"
      :resumeInfo="resumeInfo"
      :ccFormValue="ccFormValue"
    ></NoDraft>
  </div>

  <div v-else-if="currentStep == 105">
    <DraftListing :resumeDraftData="resumeDraftData"></DraftListing>
  </div>

  <div v-else-if="currentStep == 106">
    <PopulationVerification
      @next-step="nextStep"
      @previous-step="previousStep"
      :resumeInfo="resumeInfo"
      @jump-step="jumpStep"
      :otp="autoPopulationOtp"
      :type="prop.type"
      :overlay="page3Overlay"
      :cardId="prop.cardId"
      :refNo="prop.webFormDetails ? prop.webFormDetails.refNo : ''"
      @newApplication="newApplication"
      @submit="getPopulateData"
    ></PopulationVerification>
  </div>

  <div v-else-if="currentStep == 201">
    <DocumentResubmission
      :ccFormValue="ccFormValue"
      :resumeApplication="resumeApplication"
      :resumeInfo="resumeInfo"
      :resumeDraftData="resumeDraftData"
      :recruiterId="prop.rci ? prop.rci : biometricStartInfo.recruiterId"
      :verification="biometricVerification"
      :type="prop.type"
      :cardId="prop.cardId"
      :webFormRequestId="prop.webFormRequestId"
      @jump-step="jumpStep"
      @newApplication="newApplication"
      :sendBackDocSubmission="sendBackDocSubmission"
    ></DocumentResubmission>
  </div>

  <PopupMessage
    name="'none'"
    :type="timeoutType"
    :header="'timeOut'"
    v-if="
      (currentTime == 0 && !changeApplicationFlag && isTimeOut) ||
      (currentTimev2 == 0 && changeApplicationFlag && isTimeOut)
    "
    @close-modal="closeTNCModal"
    @confirmation="confirmation"
    @close-time-out-modal="closeTimeOutPopOut"
    @stayOnPage="stayOnPage"
    @changeApplication="changeApplication"
    :popup="true"
    :countDown="closeSessionTime"
    :webFormRequestId="prop.webFormRequestId"
    :changeApplicationFlag="changeApplicationFlag"
    :token="ccFormValue.token"
    :pfTimeoutFlag="pfTimeoutFlag"
    @jump-step="jumpStep"
    @stopCountDown="stopCountDown"
    @tokenSessionTimeOut="tokenSessionTimeOut"
    @changePFTimeoutFlag="changePFTimeoutFlag"
  >
  </PopupMessage>

  <PopupMessage
    name="'none'"
    :type="'none'"
    :header="'confirmation'"
    v-if="isConfirmation"
    @close-modal="closeTimeOutPopOut"
    @stayOnPage="cancelEndSession"
    :confirmationTime="confirmationTime"
    :popup="true"
    :token="ccFormValue.token"
  >
  </PopupMessage>

  <PopupMessage
    name="'none'"
    :type="'none'"
    :header="'sessionEnd'"
    v-if="isSessionEnd"
    @close-modal="closeTimeOut"
    :popup="true"
    :token="ccFormValue.token"
  >
  </PopupMessage>
</template>

<script setup lang="ts">
import BasicInformation from "./BasicInformation.vue";
import Qrcode from "./Qrcode.vue";
import ContactVerification from "./ContactVerification.vue";
import PersonalInformation from "./PersonalInformation.vue";
import EmergencyContact from "./EmergencyContact.vue";
import EmploymentDetails from "./EmploymentDetails.vue";
import PrincipalCardDetails from "./PrincipalCardDetails.vue";
import UploadDocuments from "./UploadDocuments.vue";
import Acknowledgement from "./Acknowledgement.vue";
import AdditionalInformation from "./AdditionalInformation.vue";
import BiometricStart from "./BiometricStart.vue";
import LandingPage from "./Resume/LandingPage.vue";
import PersonalInfo from "./Resume/PersonalInfo.vue";
import OTPVerification from "./Resume/OTPVerification.vue";
import NoDraft from "./Resume/NoDraft.vue";
import DraftListing from "./Resume/DraftListing.vue";
import PopulationVerification from "./Resume/PopulationVerification.vue";
import DocumentResubmission from "./Sendback/DocumentResubmission.vue";
import {
  ref,
  onMounted,
  type Ref,
  computed,
  onBeforeUnmount,
  onBeforeMount,
  watch,
} from "vue";
import { useRouter } from "vue-router";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import Summary from "./Summary.vue";
import TermsCondition from "./TermsCondition.vue";
import type FormCCOtp from "@/interface/FormCCOtp";
import SupplementaryCardDetails from "./SupplementaryCardDetails.vue";
import SupplementaryUploadFile from "./SupplementaryUploadFile.vue";
import SupplementaryContactVerification from "./SupplementaryContactVerification.vue";
import CardListing from "./CardListing.vue";
import PopupMessage from "./components/PopupMessage.vue";
import type CardType from "@/interface/CardType";
import Constants from "@/constants/constants";
import type MultiChannelLink from "@/interface/MultiChannelLink";
import type ResumePersonalInfo from "@/interface/ResumePersonalInfo";
import type BiometricStartInfo from "@/interface/BiometricStartInfo";
import type ResumeDraftData from "@/interface/ResumeDraftData";
import CCOnboardFormService from "@/service/restfulService/CCOnboardFormService";
import setBiometricInfo from "./functions/biometricAutoPopulation";
import setProductBundlingInfo from "./functions/productBundlingAutoPopulation";
import setMultiChannelInfo from "./functions/multiChannelInfo";
import setResumeAutoPopulation from "./functions/resumeAutoPopulation";
import checkBranch from "./functions/checkBranch";
import useFormCC from "./functions/formData";
import formOtp from "./functions/formOtp";
import biometricBasicInformationSubmit from "./functions/basicInformation/biometricSubmit";
import basicInformationSubmit from "./functions/basicInformation/basicInformationSubmit";
import finplusSubmit from "./functions/basicInformation/finplusSubmit";
import preAssesmentEkyc from "./functions/Qrcode/preAssesmentEkyc";
import bioCardSubmit from "./functions/cardListing/bioCardSubmit";
import crossSLCardSubmit from "./functions/cardListing/crossSLCardSubmit";
import otpPreAssesment from "./functions/contactVerification/otpPreAssesment";
import personalInformationSubmit from "./functions/personalInformation/personalInformationSubmit";
import emergencyContactSubmit from "./functions/emergencyContact/emergencyContactSubmit";
import employmentSubmit from "./functions/employmentDetails/employmentSubmit";
import principalCardSubmit from "./functions/principalCard/principalCardSubmit";
import uploadDocumentsSubmit from "./functions/uploadDocuments/uploadDocumentsSubmit";
import supplementaryCardDetailsSubmit from "./functions/supplementaryCardDetails/supplementaryCardDetailsSubmit";
import supplementaryContactVerificationSubmit from "./functions/supplementaryContactVerification/supplementaryContactVerificationSubmit";
import supplementaryUploadFileSubmit from "./functions/supplementaryUploadFile/supplementaryUploadFileSubmit";
import summarySubmit from "./functions/summary/summarySubmit";
import termsConditionSubmit from "./functions/termsCondition/termsConditionSubmit";
import additionalInformationSubmit from "./functions/additionalInformation/additionalInformationSubmit";
import type AutoPopulateDisabledField from "@/interface/AutoPopulateDisabledField";
import type PopulatedIdInfo from "@/interface/PopulatedIdInfo";
import type SendBackDocSubmission from "@/interface/SendBackDocSubmission";
import type UploadFileValidity from "@/interface/UploadFileValidity";
import setOnBoardInfo from "./functions/setOnBoardInfo";

const prop = defineProps({
  currentStep: {
    type: Number,
    required: true,
  },
  cardId: {
    type: String,
    required: true,
  },
  agentId: {
    type: String,
  },
  type: {
    type: String,
  },
  acc: {
    type: String,
  },
  bc: {
    type: String,
  },
  rci: {
    type: String,
  },
  cpc: {
    type: String,
  },
  mci: {
    type: String,
  },
  mc: {
    type: String,
  },
  crfn: {
    type: String,
  },
  data: {
    type: String,
  },
  webFormDetails: {
    type: Object,
  },
  originalUrl: {
    type: String,
  },
  errorMessage: {
    type: Array,
  },
  webFormRequestId: {
    type: String,
    required: true,
  },
  biometricCardList: {
    type: Object,
  },
  refNo: {
    type: String,
  },
  region: {
    type: String,
  },
  isDraft: {
    type: Boolean,
  },
  isReminder: {
    type: Boolean,
  },
  reminderValue: {
    type: Object,
  },
  resumeWebFormRequestId: {
    type: String,
  },
  token: {
    type: String,
    required: true,
  },
  isAutoPopulate: {
    type: Boolean,
    default: false,
  },
  checkBranchFlag: {
    type: Boolean,
    default: false,
  },
  resumedByRecruiterId: {
    type: String,
    default: "",
  },
  resumedByRecruiterName: {
    type: String,
    default: "",
  },
  remainingTime: {
    type: String,
    default: "",
  },
});

const ccFormValue = useFormCC();
let otp = formOtp();
let resumeOtp = formOtp();
let autoPopulationOtp = formOtp();

const newForm = ref(true);
const creditLimit = ref("");
const ekycGetFailed = ref(false);
const count = ref(0);
const biometricVerification = ref("false");
// determine user select resume or start at landing page
const resumeApplication = ref(false);
// backend getcif hit error indicator
const cifErrorFlag = ref(false);
const otpBackSource = ref("");

const multiChannel = ref<MultiChannelLink>({
  acc: "",
  bc: "",
  rci: "",
  cpc: "",
  mci: "",
  mc: "",
  crfn: "",
});

interface CardTypeList {
  code: string;
  value: string;
  minAge: string;
  maxAge: string;
  nationality: string;
  maxSalary: string;
  minSalary: string;
}

const cardTypeList: Ref<CardTypeList[]> = ref([]);

const biometricStartInfo = ref<BiometricStartInfo>({
  branch: "",
  recruiterId: "",
  recruiterName: "",
  applicationChannel: "",
});

const autoPopulateDisabledField = ref<AutoPopulateDisabledField>({
  icNo: false,
  militaryNo: false,
  passport: false,
  nationality: false,
  basicInformationSubmit: false,
});

const populatedIdInfo = ref<PopulatedIdInfo>({
  icNumber: "",
  passport: "",
  oldIc: "",
  militaryNo: "",
  employmentDetails: {
    postcode: "",
    sstRegistrationNo: "",
  },
  terms: {
    taxIdentificationNo: "",
  },
});

const resumeInfo = ref<ResumePersonalInfo>({
  idType: "",
  idNo: "",
  email: "",
  countryCode: "",
  mobileNo: "",
  referenceNumber: "",
  isResumedByStaff: false,
  recruiterId: "",
  recruiterName: "",
  webFormRequestId: "",
});

const uploadFileValidity = ref<UploadFileValidity>({
  uploadFile1: "",
  uploadFile2: "",
  uploadFile4: "",
  ThirdPartyUploadIdentityFileValidity: "",
  ThirdPartyUploadIncomeFileValidity: "",
  maliciousFile1Names: [],
  maliciousFile2Names: [],
  maliciousFile4Names: [],
});

const resumeDraftData = ref<ResumeDraftData[]>([]);

const sendBackDocSubmission = ref<SendBackDocSubmission>({
  referenceNo: "",
  idNo: "",
});

//30 minutes
// const totalTimeInSeconds = 5 * 60;
const resumeBundleType = ref(
  prop.reminderValue?.productBundlingExpiredtype
    ? prop.reminderValue?.productBundlingExpiredtype
    : "",
);
// On a bundle-origin resume prop.type is "CC"; the timeout popup should behave as the bundle type
// so the expiry outcome matches a fresh product-bundling timeout (FR-015).
const timeoutType = ref(
  resumeBundleType ? resumeBundleType : prop.type ? prop.type : "",
);
const totalTimeInSeconds =
  prop.type == "PF_CC" ||
  resumeBundleType.value == "PF_CC" ||
  resumeBundleType.value == "EP_CC"
    ? Constants.PRODUCT_BUNDLING_TIME_OUT
    : prop.type == "EP_CC"
      ? Number(prop.remainingTime)
      : Constants.OTHERS_TIME_OUT;
const currentTime = ref(totalTimeInSeconds);
const currentTime2 = ref(new Date());

// const totalTimeInSecondsv2 = 5 * 60;
const totalTimeInSecondsv2 = Constants.OTHERS_TIME_OUT;
const currentTimev2 = ref(totalTimeInSecondsv2);
const closeSeesionTimeInSeconds = 15;
const closeSessionTime = ref(closeSeesionTimeInSeconds);
const confirmationTime = ref(closeSeesionTimeInSeconds);
const sessionDuration = (totalTimeInSeconds + closeSeesionTimeInSeconds) * 1000;
const sessionExpirationTime = ref(
  new Date(currentTime2.value.getTime() + sessionDuration),
);
const isCountdownActive = ref(true);
const isCountdownActive2 = ref(true);
const isCountdownActive3 = ref(true);
const isCountdownActivev2 = ref(true);
// const startApplication = ref(false);
const isSessionEnd = ref(false);
const isConfirmation = ref(false);
const isTimeOut = ref(true);
const changeApplicationFlag = ref(false);
const pfTimeoutFlag = ref(false);

const formattedTime = computed(() => {
  if (isCountdownActive.value) {
    const minutes = Math.floor(currentTime.value / 60);
    const seconds = currentTime.value % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0",
    )}`;
  } else {
    return "00:00";
  }
});

const formattedTime2 = computed(() => {
  if (isCountdownActive2.value) {
    const minutes = Math.floor(closeSessionTime.value / 60);
    const seconds = closeSessionTime.value % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0",
    )}`;
  }
});

const formattedTime3 = computed(() => {
  if (isCountdownActive3.value) {
    const minutes = Math.floor(confirmationTime.value / 60);
    const seconds = confirmationTime.value % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0",
    )}`;
  }
});

const initialTime = ref(totalTimeInSeconds);
const initialTime2 = ref(closeSeesionTimeInSeconds);
const initialTime3 = ref(closeSeesionTimeInSeconds);
const initialTimev2 = ref(totalTimeInSecondsv2);
const startTime = ref(Date.now());
const startTime2 = ref(Date.now());
const startTime3 = ref(Date.now());
const startTimev2 = ref(Date.now());
// let timerInterval: number;
let timerId: number;
let timerId2: number;
let timerIdv2: number;
let intervalId2: number | undefined;
let intervalId3: number | undefined;

const updateTimer = () => {
  const elapsedTime = Math.floor((Date.now() - startTime.value) / 1000);
  const newTime = initialTime.value - elapsedTime;
  // console.log("currentTime.value", currentTime.value);
  if (Date.now() > sessionExpirationTime.value.getTime()) {
    // currentTime.value = 0;
    isCountdownActive.value = false;
    cancelAnimationFrame(timerId); // Stop the loop
    isTimeOut.value = false;
    isSessionEnd.value = true;
  } else {
    if (newTime > 0 && isCountdownActive.value) {
      currentTime.value = newTime;
      timerId = requestAnimationFrame(updateTimer);
    } else {
      currentTime.value = 0;
      isCountdownActive.value = false;
      cancelAnimationFrame(timerId); // Stop the loop
    }
  }
};

const updateTimer2 = () => {
  const elapsedTime = Math.floor((Date.now() - startTime2.value) / 1000);
  // const elapsedTime = Math.floor(Date.now() - sessionExpirationTime.getTime());
  const newTime = initialTime2.value - elapsedTime;
  // console.log("closeSessionTime.value", closeSessionTime.value);
  if (Date.now() > sessionExpirationTime.value.getTime()) {
    // currentTime.value = 0;
    isSessionEnd.value = true;
    isTimeOut.value = false;
    isCountdownActive2.value = false;
    clearInterval(intervalId2);
  } else {
    if (isCountdownActive2.value && newTime >= 0) {
      closeSessionTime.value = newTime;
      // timerId2 = requestAnimationFrame(updateTimer2); // Request the next frame
    } else {
      isCountdownActive2.value = false;
      // cancelAnimationFrame(timerId2); // Stop the loop
      clearInterval(intervalId2);
    }
  }
};

const updateTimer3 = () => {
  const elapsedTime = Math.floor((Date.now() - startTime3.value) / 1000);
  // const elapsedTime = Math.floor(Date.now() - sessionExpirationTime.getTime());
  const newTime = initialTime3.value - elapsedTime;
  // console.log("closeSessionTime.value", closeSessionTime.value);
  if (Date.now() > sessionExpirationTime.value.getTime()) {
    // currentTime.value = 0;
    isSessionEnd.value = true;
    isConfirmation.value = false;
    isCountdownActive3.value = false;
    clearInterval(intervalId3);
  } else {
    if (isCountdownActive3.value && newTime >= 0) {
      confirmationTime.value = newTime;
      // timerId2 = requestAnimationFrame(updateTimer2); // Request the next frame
    } else {
      isCountdownActive3.value = false;
      // cancelAnimationFrame(timerId2); // Stop the loop
      clearInterval(intervalId3);
    }
  }
};

const updateTimerv2 = () => {
  // const elapsedTime = Math.floor((Date.now() - startTimev2.value) / 1000);
  const elapsedTime = Math.floor((Date.now() - startTimev2.value) / 1000);
  const newTime = initialTimev2.value - elapsedTime;
  // console.log("currentTimev2.value", currentTimev2.value);
  if (isCountdownActivev2.value && newTime > 0) {
    currentTimev2.value = newTime;
    timerIdv2 = requestAnimationFrame(updateTimerv2); // Request the next frame
  } else {
    currentTimev2.value = 0;
    isCountdownActivev2.value = false;
    cancelAnimationFrame(timerIdv2); // Stop the loop
  }
};

const startCountDown = () => {
  sessionExpirationTime.value = new Date(
    new Date().getTime() + sessionDuration,
  );
  if (isCountdownActive.value) {
    startTime.value = Date.now(); // Record the start time
    updateTimer(); // Start the countdown loop
  }
};

const disabledPopout = () => {
  isTimeOut.value = false;
};

const enabledPopout = () => {
  isTimeOut.value = true;
};

const stopCountDown = () => {
  isCountdownActive2.value = false;
};

function formatTime(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

const filteredMobile = (number: String) => {
  return number.replace("+", "");
};

const resetAutoPopulationOtp = () => {
  autoPopulationOtp = formOtp();
};

onMounted(() => {
  if (prop.isDraft) ccFormValue.value.isDraft = prop.isDraft;
  if (
    prop.type == "PF_CC" ||
    prop.type == "EP_CC" ||
    prop.type == "CR_SL" ||
    prop.type == "FINPLUS" ||
    (prop.type == "BIO" && prop.webFormRequestId) ||
    prop.isAutoPopulate ||
    prop.isDraft
  )
    startCountDown();
  if (prop.webFormRequestId)
    ccFormValue.value.webFormRequestId = prop.webFormRequestId;
  currentTime2.value = new Date();

  window.onpopstate = (event: Event) => {
    parseQueryString(ccFormValue.value.selectedCard.cardId);
  };
});

onBeforeMount(() => {
  ccFormValue.value.token = prop.token;
  if (prop.reminderValue) {
    if (
      prop.checkBranchFlag ||
      (prop.reminderValue.webFormDetails.oriPrincipalCardDetail &&
        prop.reminderValue.webFormDetails.oriPrincipalCardDetail.branchValue)
    ) {
      checkBranch(ccFormValue, prop, jumpStep);
    }
  }

  if (prop.cardId) {
    ccFormValue.value.selectedCard.cardId = prop.cardId;
  }

  //Biometric Data Auto Population
  setBiometricInfo(ccFormValue, prop, biometricVerification, resumeInfo);

  //Product Bundling Data Auto Population
  setProductBundlingInfo(
    ccFormValue,
    prop,
    otp,
    creditLimit,
    multiChannel,
    biometricVerification,
    populatedIdInfo,
    filteredMobile,
  );

  setOnBoardInfo(ccFormValue, prop, resumeInfo, multiChannel, filteredMobile);

  // reminder link for otp verification
  if (prop.isReminder && prop.reminderValue) {
    resumeInfo.value.email =
      prop.reminderValue.webFormDetails.oriBasicInformation.emailAddress;
    resumeInfo.value.mobileNo =
      prop.reminderValue.webFormDetails.oriBasicInformation.mobileNumber;
    resumeInfo.value.countryCode = filteredMobile(
      prop.reminderValue.webFormDetails.oriBasicInformation.mobileCountryCode,
    );
  }

  // resume or population
  setResumeAutoPopulation(
    ccFormValue,
    prop,
    otp,
    creditLimit,
    biometricVerification,
    populatedIdInfo,
    multiChannel,
    emit,
    filteredMobile,
  );

  if (prop.type == "MC") {
    setMultiChannelInfo(multiChannel, prop);
  }

  //TODO
  if (prop.type == "FINPLUS") {
    // skip ekyc and otp
    otp.value.verified == "true";
    ccFormValue.value.ekyc.status = "COMPLETE";
  }

  MasterService.cardType()
    .then((res) => {
      cardTypeList.value = res.data.responseModel.cardTypeList;
      const cardObject = cardTypeList.value.find(
        (cardType) => cardType.code === prop.cardId,
      );
      if (cardObject) {
        ccFormValue.value.cardName = cardObject.value;
        ccFormValue.value.cardMinSalary = cardObject.minSalary;
      } else {
        ccFormValue.value.cardName = "";
        ccFormValue.value.cardMinSalary = "";
      }
    })
    .catch((e) => {});

  window.addEventListener("pagehide", handleBeforeUnload);
  window.addEventListener("keydown", handleKeyDown);
});

// watch(
//   () => prop.currentStep,
//   (newStep) => {
//     isCountdownActive.value = newStep !== 2;
//   }
// );

const step = ref();
//If update emit, update in resumeAutoPopulation.ts also
const emit = defineEmits([
  "nextStep",
  "previousStep",
  "jumpStep",
  "update:currentStep",
  "submit",
  "ekycGenerate",
  "listenerEkyc",
  "setCardId",
]);
const status = ref("");

const router = useRouter();

step.value = prop.currentStep;

const jumpStep = (value: Number, name: string, page: string) => {
  if (value == 14) {
    if (
      !(
        name == "cardApplicationUnsucessful" ||
        name == "cardApplicationNotQualify"
      )
    ) {
      isTimeOut.value = false;
      isCountdownActive.value = false;
      isCountdownActive2.value = false;
      isCountdownActivev2.value = false;
    }
  }
  if (value == 102) {
    if (name == "resume") {
      // bio set default toggle button as staff
      if (prop.type == "BIO") {
        ccFormValue.value.activeButton = "staff";
      }
      resumeApplication.value = true;
    } else {
      ccFormValue.value.activeButton = "customer";
      resumeApplication.value = false;
    }
  }
  if (value == 103) {
    otpBackSource.value = name;
  }
  if (page == "1" && value == 10) {
    status.value = name;
    step.value = Number(value);
    emit("nextStep", step.value);
  } else {
    status.value = name;
    step.value = Number(value);
    emit("nextStep", step.value);
  }
};

const nextStep = () => {
  step.value = step.value + 1;
  emit("nextStep", step.value);
};

const previousStep = () => {
  step.value = step.value - 1;
  emit("previousStep", step.value);
};

const getProductStepFromBackend = (
  forward: boolean,
  backward: boolean,
  resume: boolean,
  autoPopulated: boolean,
  summaryEditBtn: string,
) => {
  const requestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    currentStep: String(prop.currentStep),
    forward: forward,
    backward: backward,
    resume: resume,
    autoPopulated: autoPopulated,
    summaryEditBtn: summaryEditBtn,
  };
  MasterService.productFlow(requestModel)
    .then((res) => {
      if (res.status == 200) {
        if (res.data.responseModel.acknowledgementStatus) {
          status.value = res.data.responseModel.acknowledgementStatus;
        }
        step.value = Number(res.data.responseModel.stepCode);
        emit("nextStep", step.value);
      }
    })
    .catch((e) => {});
};

const setCardId = () => {
  emit("setCardId", ccFormValue.value.selectedCard.cardId);
};

const setCardName = () => {
  ccFormValue.value.cardName = ccFormValue.value.selectedCard.cardName;
};

const failedStatus = ref(false);
//Landing
const getDataLanding = ref(false);

const landingPageOverlay = () => {
  getDataLanding.value = !getDataLanding.value;
};

//Submmision
//Basic Information
const page1Overlay = ref(false);
const page0Overlay = ref(true);

const is0Overlay = () => {
  page0Overlay.value = true;
};

const close0Overlay = () => {
  page0Overlay.value = false;
};

const isOverlay = () => {
  page1Overlay.value = true;
};

const closeOverlay = () => {
  page1Overlay.value = false;
};

//flag to check gross salary change in pa (true for no change)
const bioExist = ref(false);

const cardSubmit = () => {
  const cardSubmissionRequestModel = {
    webFormRequestId: prop.webFormRequestId,
    cardId: prop.cardId,
  };

  MasterService.cardSubmission(cardSubmissionRequestModel, prop.token)
    .then((res) => {
      if (res.status == 200) {
        // go to additional information page
        jumpStep(1, "", "0");
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        tokenSessionTimeOut();
      }
      enabledPopout();
    });
};

const handleBiometricSubmit = () => {
  biometricBasicInformationSubmit(
    ccFormValue,
    prop,
    multiChannel,
    biometricStartInfo,
    newForm,
    page1Overlay,
    biometricVerification,
    isTimeOut,
    isSessionEnd,
    jumpStep, // Pass the jumpStep function here
  );
};

const biometricCardSubmit = () => {
  bioCardSubmit(
    ccFormValue,
    page0Overlay,
    bioExist,
    biometricVerification,
    isTimeOut,
    isSessionEnd,
    prop,
    resumeOtp,
    otp,
    creditLimit,
    failedStatus,
    cifErrorFlag,
    jumpStep,
  );
};

const crossSellingCardSubmit = () => {
  crossSLCardSubmit(
    ccFormValue,
    page0Overlay,
    biometricVerification,
    isTimeOut,
    isSessionEnd,
    prop,
    creditLimit,
    failedStatus,
    jumpStep,
  );
};

const handleBasicInformationSubmit = () => {
  basicInformationSubmit(
    ccFormValue,
    prop,
    multiChannel,
    otp,
    isTimeOut,
    isSessionEnd,
    page1Overlay,
    failedStatus,
    creditLimit,
    status,
    newForm,
    cifErrorFlag,
    biometricVerification,
    jumpStep, // Pass the jumpStep function here
  );
};

const handleFinplusSubmit = () => {
  finplusSubmit(
    ccFormValue,
    prop,
    isTimeOut,
    isSessionEnd,
    page1Overlay,
    creditLimit,
    jumpStep,
  );
};

//QR
const qr = () => {
  ccFormValue.value.ekyc.refreshBtnDisabled = true;
  ccFormValue.value.ekyc.backBtnDisabled = true;
  ccFormValue.value.ekyc.fail = false;
  const requestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    customerName: ccFormValue.value.basicInformation.name,
    idNo: ccFormValue.value.basicInformation.idNo,
  };
  MasterService.ekycGenerate(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        ccFormValue.value.ekyc.url = res.data.responseModel.onboardingUrl;
        ccFormValue.value.ekyc.refId = res.data.responseModel.refId;
        ccFormValue.value.ekyc.webFormRequestId =
          res.data.responseModel.webFormRequestId;
        ccFormValue.value.ekyc.refreshBtnDisabled = false;
        ccFormValue.value.ekyc.backBtnDisabled = false;
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
        ccFormValue.value.ekyc.refreshBtnDisabled = false;
        ccFormValue.value.ekyc.backBtnDisabled = false;
      } else {
        setTimeout(() => {
          ccFormValue.value.ekyc.fail = true;
          ccFormValue.value.ekyc.refreshBtnDisabled = false;
          ccFormValue.value.ekyc.backBtnDisabled = false;
        }, 25000);
      }
    });
};

const page2Overlay = ref(false);
const updateFlag = () => {
  page2Overlay.value = true;
  ccFormValue.value.ekyc.action = "B";
  const requestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    dropOffStep: "S3",
    action: "B",
  };
  MasterService.pageSubmit(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        page2Overlay.value = false;
        ccFormValue.value.dropOffStep = 1;

        // jumpStep(1, "", "2");
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page2Overlay.value = false;
    });
};

const updateOTPFlag = () => {
  const requestModel2 = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    type: "CC_P",
    otpType: "mobileOtp",
  };
  CCOnboardFormService.updateStatus(requestModel2, prop.token)
    .then((res) => {
      if (res.status == 200) {
        const requestModel3 = {
          webFormRequestId: ccFormValue.value.webFormRequestId,
          type: "CC_P",
          otpType: "emailOtp",
        };
        CCOnboardFormService.updateStatus(requestModel3, prop.token)
          .then((res) => {
            if (res.status == 200) {
              if (
                prop.type == "CR_SL" &&
                !(prop.isDraft || prop.isAutoPopulate)
              ) {
                router.push({
                  name: "CCProgressRoutePage",
                  state: {
                    draftListing: true,
                    isAutoPopulate: true,
                  },
                  query: {
                    webFormRequestId: ccFormValue.value.webFormRequestId,
                  },
                });
              }
            }
          })
          .catch((e) => {
            if (e.response && e.response.data.code == "WB-401") {
              // EndSession
              isTimeOut.value = false;
              isSessionEnd.value = true;
            }
          });
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
    });
};

const listenerEkyc = () => {
  const intervalId = ref(0);
  const requestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    ekycRefNo: ccFormValue.value.ekyc.refId,
  };

  const startInterval = () => {
    const intervalFunction = () => {
      if (
        ccFormValue.value.ekyc.status != "COMPLETE" &&
        ccFormValue.value.ekyc.status != "SKIP" &&
        ccFormValue.value.ekyc.status != "FAILED" &&
        ccFormValue.value.ekyc.action != "B" &&
        isCountdownActive.value
      ) {
        const requestModel = {
          webFormRequestId: ccFormValue.value.webFormRequestId,
          ekycRefNo: ccFormValue.value.ekyc.refId,
        };

        MasterService.ekycCheckStatus(requestModel, ccFormValue.value.token)
          .then((res) => {
            if (res.status == 200) {
              if (res.data.responseModel.status != "PENDING") {
                if (res.data.responseModel.status != "SKIP") {
                  ccFormValue.value.ekyc.status = res.data.responseModel.status;
                  if (res.data.responseModel.status == "COMPLETE") {
                    ccFormValue.value.ekyc.completedInCC = true;
                  }
                }
              }
            }
          })
          .catch((e) => {
            ekycGetFailed.value = true;
            if (e.response && e.response.data.code == "WB-401") {
              // EndSession
              isTimeOut.value = false;
              isSessionEnd.value = true;
            }
          })
          .finally(() => {
            if (
              ccFormValue.value.ekyc.status == "COMPLETE" ||
              ccFormValue.value.ekyc.status == "SKIP" ||
              ccFormValue.value.ekyc.status == "FAILED" ||
              ccFormValue.value.ekyc.action == "B"
            ) {
            } else {
              if (
                ccFormValue.value.basicInformation.idType == "0" &&
                ccFormValue.value.ekyc.status == ""
              ) {
                setTimeout(intervalFunction, 10000);
              }
            }
          });
      }
    };
    intervalFunction();
  };
  startInterval();
};

const handleQrcodeSubmit = () => {
  preAssesmentEkyc(
    ccFormValue,
    page2Overlay,
    prop,
    creditLimit,
    isTimeOut,
    isSessionEnd,
    jumpStep,
    updateOTPFlag,
  );
};

//OTP
const page3Overlay = ref(false);
const preAssesment = () => {
  otpPreAssesment(
    ccFormValue,
    prop,
    page3Overlay,
    creditLimit,
    isTimeOut,
    isSessionEnd,
    jumpStep,
  );
};

const page4Overlay = ref(false);
//Personal Information
const handlePersonalInformationSubmit = () => {
  personalInformationSubmit(
    ccFormValue,
    prop,
    page4Overlay,
    isTimeOut,
    isSessionEnd,
    jumpStep,
  );
};

const page15Overlay = ref(false);
const handleAdditionalInformationSubmit = () => {
  additionalInformationSubmit(
    ccFormValue,
    prop,
    page15Overlay,
    isTimeOut,
    isSessionEnd,
    jumpStep,
    getProductStepFromBackend,
  );
};

const page5Overlay = ref(false);
//Emergency Contact
const handleEmergencyContactSubmit = () => {
  emergencyContactSubmit(
    ccFormValue,
    prop,
    page5Overlay,
    isTimeOut,
    isSessionEnd,
    jumpStep,
  );
};

//Employment Details
const page6Overlay = ref(false);
const handleEmploymentSubmit = () => {
  employmentSubmit(
    ccFormValue,
    prop,
    page6Overlay,
    isTimeOut,
    isSessionEnd,
    jumpStep,
  );
};

//Principal Card Details
const page7Overlay = ref(false);
const principalSubmit = () => {
  principalCardSubmit(
    ccFormValue,
    prop,
    page7Overlay,
    isTimeOut,
    isSessionEnd,
    jumpStep,
  );
};

//Upload Document
const page8Overlay = ref(false);
const fileSubmit = () => {
  uploadDocumentsSubmit(
    ccFormValue,
    prop,
    page8Overlay,
    isTimeOut,
    isSessionEnd,
    status,
    uploadFileValidity,
    multiChannel,
    jumpStep,
    getProductStepFromBackend,
    resumeBundleType,
  );
};

//Supplementary Card
const page9Overlay = ref(false);

const suppSubmit = () => {
  supplementaryCardDetailsSubmit(
    ccFormValue,
    prop,
    page9Overlay,
    isTimeOut,
    isSessionEnd,
    otp,
    jumpStep,
  );
};

const page10Overlay = ref(false);
const suppOtpFail = () => {
  supplementaryContactVerificationSubmit(
    ccFormValue,
    page10Overlay,
    isTimeOut,
    isSessionEnd,
    jumpStep,
  );
};

//Supplementary - Upload File
const page11Overlay = ref(false);
const suppStatus = ref("");
const suppFileSubmit = () => {
  supplementaryUploadFileSubmit(
    ccFormValue,
    page11Overlay,
    isTimeOut,
    isSessionEnd,
    suppStatus,
    uploadFileValidity,
    jumpStep,
  );
};

//Summary
const page12Overlay = ref(false);
const handleSummarySubmit = () => {
  summarySubmit(
    ccFormValue,
    prop,
    page12Overlay,
    isTimeOut,
    isSessionEnd,
    jumpStep,
    getProductStepFromBackend,
    resumeBundleType,
  );
};

//Terms
const termsSubmitFail = ref(false);
const page13Overlay = ref(false);

const closeTNCModal = () => {
  isTimeOut.value = true;
  termsSubmitFail.value = false;
  isSessionEnd;
};

const stayOnPage = () => {
  if (changeApplicationFlag.value) {
    sessionExpirationTime.value = new Date(
      sessionExpirationTime.value.getTime() -
        closeSessionTime.value * 1000 +
        parseInt(totalTimeInSecondsv2 + closeSeesionTimeInSeconds) * 1000,
    );
    closeSessionTime.value = closeSeesionTimeInSeconds;
    initialTime2.value = closeSeesionTimeInSeconds;
    isCountdownActive2.value = false;
    currentTimev2.value = totalTimeInSecondsv2;
    initialTimev2.value = totalTimeInSecondsv2;
    isCountdownActivev2.value = true;
    startTimev2.value = Date.now();

    updateTimerv2();
  } else {
    sessionExpirationTime.value = new Date(
      sessionExpirationTime.value.getTime() -
        closeSessionTime.value * 1000 +
        (totalTimeInSeconds + closeSeesionTimeInSeconds) * 1000,
    );
    closeSessionTime.value = closeSeesionTimeInSeconds;
    initialTime2.value = closeSeesionTimeInSeconds;
    isCountdownActive2.value = false;
    currentTime.value = totalTimeInSeconds;
    initialTime.value = totalTimeInSeconds;
    isCountdownActive.value = true;
    startCountDown();
  }
};

const changeApplication = () => {
  sessionExpirationTime.value = new Date(
    sessionExpirationTime.value.getTime() -
      closeSessionTime.value * 1000 +
      parseInt(totalTimeInSecondsv2 + closeSeesionTimeInSeconds) * 1000,
  );
  closeSessionTime.value = closeSeesionTimeInSeconds;
  initialTime2.value = closeSeesionTimeInSeconds;
  // isCountdownActive2.value = false;

  changeApplicationFlag.value = true;
  isCountdownActivev2.value = true;
  startTimev2.value = Date.now();

  updateTimerv2();
};

const changePFTimeoutFlag = () => {
  pfTimeoutFlag.value = true;
};

const closeTimeOutPopOut = () => {
  isTimeOut.value = false;
  isConfirmation.value = false;
  isSessionEnd.value = true;
  // if (interval != null) clearInterval(interval);
};

const confirmation = () => {
  sessionExpirationTime.value = new Date(
    sessionExpirationTime.value.getTime() -
      closeSessionTime.value * 1000 +
      closeSeesionTimeInSeconds * 1000,
  );
  isTimeOut.value = false;
  isConfirmation.value = true;
  isCountdownActive2.value = false;
  isCountdownActive3.value = true;
  startTime3.value = Date.now();
  intervalId3 = setInterval(updateTimer3, 1000);
};

const cancelEndSession = () => {
  sessionExpirationTime.value = new Date(
    sessionExpirationTime.value.getTime() -
      confirmationTime.value * 1000 +
      closeSeesionTimeInSeconds * 1000,
  );
  isConfirmation.value = false;
  isTimeOut.value = true;
  closeSessionTime.value = closeSeesionTimeInSeconds;
  initialTime2.value = closeSeesionTimeInSeconds;
  confirmationTime.value = closeSeesionTimeInSeconds;
  initialTime3.value = closeSeesionTimeInSeconds;
  isCountdownActive2.value = true;
  isCountdownActive3.value = false;
  startTime2.value = Date.now();
  if (
    !(prop.type == "PF_CC" || prop.type == "EP_CC") ||
    changeApplicationFlag.value
  )
    intervalId2 = setInterval(updateTimer2, 1000); // Update every second
};

const closeTimeOut = () => {
  parseQueryString(ccFormValue.value.selectedCard.cardId);
};

const parseQueryString = (cardId: any) => {
  var localCardId = prop.cardId ? prop.cardId : cardId ? cardId : "NA";
  localStorage.setItem("cardId", localCardId);
  const cardType: Ref<CardType[]> = ref([]);

  if (ccFormValue.value.webFormRequestId) {
    const requestModel = {
      webFormRequestId: ccFormValue.value.webFormRequestId,
    };
    MasterService.dropOff(requestModel, ccFormValue.value.token);
  }
  const params = new URLSearchParams(window.location.search);
  if (params.has("cc") && !params.has("type")) {
    const param1 = params.get("cc") || "";

    MasterService.cardType().then((res) => {
      cardType.value = res.data.responseModel.cardTypeList;
      const cardObject = cardType.value.find(
        (cardType) => cardType.code === param1,
      );

      if (cardObject) {
        router.push({ name: "CCOnboard", query: { cc: param1 } }).then(() => {
          setTimeout(() => {
            window.location.reload(); // true forces a reload from the server
          }, 100);
        });
      } else {
        router.push({ name: "CCOnboard", query: { cc: "NA" } }).then(() => {
          setTimeout(() => {
            window.location.reload(); // true forces a reload from the server
          }, 100);
        });
      }
    });
    // }
  } else if (params.has("CPC")) {
    window.location.reload();
  } else if (params.has("webFormRequestId")) {
    const param2 = params.get("webFormRequestId") || "";

    if (prop.type == "BIO") {
      if (cardId != "") {
        router
          .push({
            name: "CCOnboard",
            state: {
              type: "BIO",
            },
            query: { cc: cardId, type: "BIO" },
          })
          .then(() => {
            setTimeout(() => {
              window.location.reload(); // true forces a reload from the server
            }, 100);
          });
      } else if (prop.cardId != "") {
        router
          .push({
            name: "CCOnboard",
            state: {
              type: "BIO",
            },
            query: { cc: prop.cardId, type: "BIO" },
          })
          .then(() => {
            setTimeout(() => {
              window.location.reload(); // true forces a reload from the server
            }, 100);
          });
      } else {
        router
          .push({
            name: "CCOnboard",
            state: {
              type: "BIO",
            },
            query: { cc: "NA", type: "BIO" },
          })
          .then(() => {
            setTimeout(() => {
              window.location.reload(); // true forces a reload from the server
            }, 100);
          });
      }
    } else if (prop.type == "CR_SL") {
      router.push({
        name: "CCOnboard",
        query: {
          ACC: "W1",
          BC: "0101",
          RCI: "NA",
          CPC: "NA",
          MCI: "NA",
          MC: "NA",
          CRFN: "NA",
        },
      });
    } else {
      if (cardId != "") {
        router.push({ name: "CCOnboard", query: { cc: cardId } }).then(() => {
          setTimeout(() => {
            window.location.reload(); // true forces a reload from the server
          }, 100);
        });
      } else if (prop.cardId != "") {
        router
          .push({ name: "CCOnboard", query: { cc: prop.cardId } })
          .then(() => {
            setTimeout(() => {
              window.location.reload(); // true forces a reload from the server
            }, 100);
          });
      } else {
        router.push({ name: "CCOnboard", query: { cc: "NA" } }).then(() => {
          setTimeout(() => {
            window.location.reload(); // true forces a reload from the server
          }, 100);
        });
      }
    }
  } else if (params.has("cc") && params.has("type")) {
    const param1 = params.get("cc") || "";
    const param2 = params.get("type") || "";

    MasterService.cardType().then((res) => {
      cardType.value = res.data.responseModel.cardTypeList;
      const cardObject = cardType.value.find(
        (cardType) => cardType.code === param1,
      );

      if (cardObject) {
        router
          .push({
            name: "CCOnboard",
            state: {
              type: "BIO",
            },
            query: { cc: param1, type: param2 },
          })
          .then(() => {
            setTimeout(() => {
              window.location.reload(); // true forces a reload from the server
            }, 100);
          });
      } else {
        router
          .push({
            name: "CCOnboard",
            state: {
              type: "BIO",
            },
            query: { cc: "NA", type: param2 },
          })
          .then(() => {
            setTimeout(() => {
              window.location.reload(); // true forces a reload from the server
            }, 100);
          });
      }
    });
  } else {
    router.push({ name: "Acknowledgement", query: { status: "denied" } });
  }
};

const declarationSubmit = () => {
  termsConditionSubmit(
    ccFormValue,
    prop,
    page13Overlay,
    isTimeOut,
    isSessionEnd,
    termsSubmitFail,
    creditLimit,
    count,
    jumpStep,
  );
};

const getPopulateData = () => {
  if (prop.type == "FINPLUS") {
    getDataLanding.value = true;
  } else {
    page3Overlay.value = true;
  }
  const requestModel = {
    cifNo: ccFormValue.value.cifNo,
    branch: biometricStartInfo.value.branch
      ? biometricStartInfo.value.branch
      : prop.bc != "NA"
        ? prop.bc
        : "",
    recruiterId: biometricStartInfo.value.recruiterId
      ? biometricStartInfo.value.recruiterId
      : prop.rci && prop.rci != "NA"
        ? prop.rci
        : "",
    applicationChannel: biometricStartInfo.value.applicationChannel
      ? biometricStartInfo.value.applicationChannel
      : prop.acc != "NA"
        ? prop.acc
        : "",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    type: prop.type,
    tmkCrmRefNo: prop.crfn && prop.crfn != "NA" ? prop.crfn : "",
    marketingCampaignId: prop.mci && prop.mci != "NA" ? prop.mci : "",
    merchantId: prop.mc && prop.mc != "NA" ? prop.mc : "",
    recruiterName: biometricStartInfo.value.recruiterName
      ? biometricStartInfo.value.recruiterName
      : "",
    originalUrl: prop.originalUrl,
    errorMessage: prop.errorMessage,
    cardId: prop.cardId == "NA" ? "" : prop.cardId,
  };
  if (prop.type == "CR_SL") {
    updateOTPFlag();
  } else {
    MasterService.getCIF(requestModel)
      .then((res) => {
        if (prop.type == "FINPLUS") {
          getDataLanding.value = false;
        } else {
          page3Overlay.value = false;
        }
        if (
          res.data.responseModel.isACSMCustomer == "N" ||
          res.data.responseModel.isDataEmpty == "Y"
        ) {
          newApplication();
          if (
            (prop.cardId == "NA" || prop.cardId == "") &&
            prop.type != "BIO"
          ) {
            jumpStep(0, "", "4");
          } else jumpStep(1, "", "4");
        } else {
          router.push({
            name: "CCProgressRoutePage",
            state: {
              draftListing: true,
              isAutoPopulate: true,
            },
            query: {
              webFormRequestId: res.data.responseModel.webFormRequestId,
            },
          });
        }
      })
      .catch((e) => {
        cifErrorFlag.value = true;
        newApplication();
        if (
          (prop.cardId == "NA" || prop.cardId == "") &&
          prop.type != "BIO" &&
          prop.type != "FINPLUS"
        ) {
          jumpStep(0, "", "4");
        } else jumpStep(1, "", "4");
      });
  }
};

const tokenSessionTimeOut = () => {
  isTimeOut.value = false;
  isSessionEnd.value = true;
};

watch(
  () => count.value,
  (newValue) => {
    if (newValue > 3) {
      page13Overlay.value = false;
      jumpStep(14, "denied", "13");
    }
  },
);

watch(
  () => currentTime.value,
  (newValue) => {
    if (newValue == 0 && isTimeOut.value) {
      formattedTime2;
      // interval = setInterval(updateTimer2, 1000);
      startTime2.value = Date.now();
      isCountdownActive2.value = true;
      if (!(prop.type == "PF_CC" || prop.type == "EP_CC"))
        intervalId2 = setInterval(updateTimer2, 1000); // Update every second
    }
  },
);

watch(
  () => currentTimev2.value,
  (newValue) => {
    if (newValue == 0 && isTimeOut.value) {
      startTime2.value = Date.now();
      isCountdownActive2.value = true;
      intervalId2 = setInterval(updateTimer2, 1000);
    }
  },
);

onBeforeUnmount(() => {
  window.removeEventListener("pagehide", handleBeforeUnload);
  window.removeEventListener("keydown", handleKeyDown);
});

const handleBeforeUnload = (event: Event) => {
  parseQueryString(ccFormValue.value.selectedCard.cardId);
};

const handleKeyDown = (event: KeyboardEvent) => {
  if (event.altKey && event.key === "F4") {
    if (ccFormValue.value.webFormRequestId) {
      const requestModel = {
        webFormRequestId: ccFormValue.value.webFormRequestId,
      };
      MasterService.dropOff(requestModel, ccFormValue.value.token);
    }
  }
};

const newApplication = () => {
  ccFormValue.value.basicInformation.idNo = resumeInfo.value.idNo;
  ccFormValue.value.basicInformation.idType = resumeInfo.value.idType;
  ccFormValue.value.basicInformation.email = resumeInfo.value.email;
  ccFormValue.value.basicInformation.countryCode = resumeInfo.value.countryCode;
  ccFormValue.value.basicInformation.mobileNo = resumeInfo.value.mobileNo;
  if (biometricVerification.value == "false" && prop.type != "FINPLUS") {
    startCountDown();
  }
};
</script>

<style scoped></style>
